import { render, staticRenderFns } from "./_callLogsModal.vue?vue&type=template&id=4b260d0c"
import script from "./_callLogsModal.vue?vue&type=script&lang=js"
export * from "./_callLogsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports